import { apiCallCenter } from '@/plugins/axios'

export default {
  getQueues() {
    return apiCallCenter().get('/relatorios/filas/filas/lazy')
  },
}
